import Immutable from 'seamless-immutable'

export default Immutable({
  geometries: [],
  cameras: [],
  lights: [],
})



// WEBPACK FOOTER //
// ./src/store/objects/objects.model.js